import { useEffect, useRef, useState } from 'react';
import config from '/config';
import '/assets/styles/pages/place-order.scss';

// Partials
import QrReader from '/views/partials/qr-reader';

// Context
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useBranchSelection } from '/utilities/branch-selection';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';

const PlaceOrder = () => {
	const { redirect } = useNavigator();
	const { openModal } = useModals();
	const { submitMenuUrl } = useBranchSelection();
	const submittingQrRef = useRef(false);
	const [submittingQr, setSubmittingQrRaw] = useState(submittingQrRef.current);

	const setSubmittingQr = (newState) => {
		submittingQrRef.current = newState;
		setSubmittingQrRaw(submittingQrRef.current);
	};

	const readQr = (menuUrl) => {
		if (!submittingQrRef.current && menuUrl) {
			setSubmittingQr(true);

			submitMenuUrl(menuUrl)
				.then(() => {
					redirect('home');
				})
				.catch((feedback) => {
					openModal('message', { feedback });
				});
		}
	};

	useEffect(() => {
		if (config.autoQrReadURL?.length) {
			setTimeout(() => {
				readQr(config.autoQrReadURL);
			}, 2000);
		}
	}, []);

	return (
		<>
			<QrReader onSuccess={readQr} submittingQr={submittingQr} className="order-reader" />
		</>
	);
};

export default PlaceOrder;
